import { jsx as i } from "react/jsx-runtime";
import { IconButton as e } from "../icon-button/icon-button.js";
import { Icons as a } from "../icon/types.js";
function u({ buttonSize: o, ariaLabel: r, onClick: t, isDisabled: n }) {
  return /* @__PURE__ */ i(
    e,
    {
      variant: "ghost",
      icon: a.Decrease,
      "aria-label": r,
      size: o,
      onClick: t,
      isDisabled: n
    }
  );
}
export {
  u as MinusButton
};
